import moment from 'moment';

export const getFormattedDate = (date) => {
  return moment(date).format('DD/MM/YYYY - HH:mm');
};
